import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Modal, message, Tag } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_edit_ssp_school_target_detail_night,
  req_list_ssp_planner_studentsource_night,
  req_downloadfile_ssp_planner_studentsource_night,
} from "../../api";

class NightStudentDepartmentViewList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    row: {
      Gid: "",
      YearMonth: "",
      PlanAcademicYear: "",
      AcademicSystem: "四技",
      UniversityCode: "1051",
      CollegeCode: "",
      TargetDepartmentCode: "",
      PrincipalCode: "",
      SourceCode: "",
      HighSchoolCode: "",
      SourceDepartmentCode: "",
      NumberOfPeople: 0,
      RecordCreatorId: "",
      RecordEditorId: "",
    },
    obj: {},
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "民生暨管理學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "二技", value: "二技" },
    ],
    sourceCodes: [
      // { value: "AA", label: "商管群(A)" },
      // { value: "AB", label: "餐旅群(A)" },
      // { value: "AC", label: "設計群(A)" },
      // { value: "AD", label: "藝術群(A)" },
      // { value: "AE", label: "機械群(A)" },
      // { value: "AF", label: "食品群(A)" },
      // { value: "AG", label: "土木群(A)" },
      // { value: "AH", label: "外語群英語類(A)" },
      // { value: "AI", label: "電子與電機群資電類(A)" },
      // { value: "AJ", label: "家政群生活應用類(A)" },
      // { value: "AK", label: "家政群幼保類(A)" },
      // { value: "AM", label: "農業類(A)" },
      // { value: "BA", label: "藝術單招(B1)" },
      // { value: "BB", label: "特殊選才(B2)" },
      // { value: "BC", label: "繁星入學(B3)" },
      // { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      // { value: "DA", label: "技優甄審(D)" },
    ],
    selectedCountyCityName: "NONE",
    selectedCollege: "NONE",
    selectedTargetdepart: "NONE",
    selectedAcademicSystem: "四技",
    selectedTargetprincipal: "NONE",
    selectedSourceCode: "NONE",
    selectedHighSchoolCode: "NONE",
    selectedSourceDepartmentCode: "NONE",
  };

  constructor(props) {
    super(props);
    this.handleVisitedChange = this.handleVisitedChange.bind(this);
  }

  componentWillMount() {
    this.api_list_studentsource();
  }

  //////////
  api_edit_item = async (row) => {
    const { token, userCode } = this.props.user;
    row.RecordEditorId = userCode;
    await req_edit_ssp_school_target_detail_night(row, token);
    this.handle_data_refresh();
  };

  api_list_studentsource = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_planner_studentsource_night(
      userCode,
      "VIEWER",
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      const items = [];
      this.setState({ data: items });
    }
  };

  api_list_studentsource_noloading = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_planner_studentsource_night(
      userCode,
      "VIEWER",
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      const items = [];
      this.setState({ data: items });
    }
  };

  api_downloadfile_items = async () => {
    const { planAcademicYear } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_ssp_planner_studentsource_night(
      userCode,
      "VIEWER",
      planAcademicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    this.api_list_studentsource();
    console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    const { Gid } = item;
    switch (modal) {
      case "add":
        this.handle_data_refresh();
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆生源規劃`,
          onOk: () => {
            this.api_delete_item(Gid);
          },
        });
        break;
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        NumberOfPeople: getValue,
        NumberConfident: getValue,
        RecordEditorId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  handleVisitedChange(event, item) {
    const { value } = event.target;
    const { Gid } = item;
    const { userCode } = this.props.user;
    const row = {
      Gid: Gid,
      VisitedStatus: value,
      VistedEditorId: userCode,
      condition: "VISITED",
    };
    this.api_edit_item(row);
  }

  //////////
  render() {
    const { planAcademicYear, data, loading } = this.state;
    const columns = [
      {
        title: "負責人",
        align: "center",
        responsive: ["lg"],
        dataIndex: "TwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        align: "center",
        responsive: ["lg"],
        dataIndex: "AcademicSystem",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        responsive: ["lg"],
        dataIndex: "CollegeName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "TargetDepartmentName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源縣市",
        align: "center",
        responsive: ["lg"],
        dataIndex: "CountyCityName",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900, background: "#DDDDFF" },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源學校",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900, background: "#DDDDFF" },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源科班",
        dataIndex: "HighSchoolDepartmentName",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900, background: "#DDDDFF" },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "招生管道",
        align: "center",
        dataIndex: "SourceName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "規劃員額",
        width: "80px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { NumberOfPeople } = item;
          return (
            <span style={{ color: "blue", fontWeight: 900 }}>
              {NumberOfPeople}
            </span>
          );
        },
      },
      {
        title: "預收員額",
        width: "80px",
        align: "left",
        fixed: "true",
        render: (item) => {
          const { NumberConfident, Gid } = item;
          return (
            <>
              <Input
                type="number"
                placeholder="人數"
                style={{
                  fontWeight: 900,
                  backgroundColor: "LightYellow",
                  color: "green",
                }}
                defaultValue={NumberConfident}
                onChange={(e) => this.handle_ui_field_change(Gid, "QUOTB", e)}
              />
            </>
          );
        },
      },
      {
        title: "實地拜訪",
        width: "70px",
        align: "left",
        fixed: "true",
        render: (item) => {
          const { VisitedStatus } = item;
          return (
            <>
              {VisitedStatus === "Y" ? (
                <Tag color="green">已訪</Tag>
              ) : (
                <Tag color="orange">待訪</Tag>
              )}

              {/* <select
                className="form-control"
                style={{
                  width: "90px",
                  display: "inline-block",
                  backgroundColor:
                    VisitedStatus === "Y" ? "LightGreen" : "LightYellow",
                }}
                onChange={(e) => this.handleVisitedChange(e, item)}
                value={VisitedStatus}
              >
                <option value="N" key="N">
                  待訪
                </option>
                <option value="Y" key="Y">
                  已訪
                </option>
              </select> */}
            </>
          );
        },
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",

            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>

        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(NightStudentDepartmentViewList);
